import { Button } from "../Button/Button";
import { TableAction } from "../Table/Table";

const ActionsBar = ({ actions }: { actions: TableAction[] }) => {
  return (
    <div className="flex flex-1 flex-row flex-wrap items-center justify-start gap-2 md:justify-end">
      {actions?.filter(a => a?.visible !== false)?.map((action) => {
        return (
          <Button
            className="text-xs sm:text-sm"
            type={action.type || "primary"}
            variant={action.variant || "filled"}
            key={action?.label}
            onClick={action?.onClick}
            startIcon={action?.icon ? <div className={`${action.icon} h-4 w-4`} /> : undefined}
          >
            {action?.label}
          </Button>
        );
      })}
    </div>
  );
};

export default ActionsBar;
